import createRoute from '@widesk-ui/tools/createRoute';
import EventModel  from '@models/website/EventModel';

const route = createRoute.dashboardFromModel(
	EventModel,
	'EventDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	},
);
export default route;
